import {ContentfulClientApi, Entry, createClient} from 'contentful';

// eslint-disable-next-line no-shadow
export enum ContentType {
  Announcement = 'announcement',
  HelpFaq = 'helpFaq',
}

interface SortableContent {
  order: number;
}

export interface GetContentOptions {
  contentType: ContentType;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const getContent = <T>(options: GetContentOptions): Entry<T>[] => {
  const entries: Entry<T>[] = [];

  return entries;
};

const sortContentByOrder = <T extends SortableContent>(entries: Entry<T>[]): Entry<T>[] =>
  entries.sort((entryA, entryB) => (entryA.fields.order > entryB.fields.order ? 1 : -1));

const formatEntry = <T>(entries: Entry<T>[]): T[] => entries.map((entry) => entry.fields);

export const getSortedContent = <T extends SortableContent>(options: GetContentOptions): T[] => {
  const entries = getContent<T>(options);
  const sortedEntries = sortContentByOrder<T>(entries);
  const formattedEntries = formatEntry<T>(sortedEntries);

  return formattedEntries;
};

export default {
  /**
   * @deprecated
   * Please use one of the helper methods.
   */
  client(): ContentfulClientApi {
    const client: ContentfulClientApi = createClient({
      environment: process.env.VUE_APP_CMS_ENVIRONMENT,
      space: process.env.VUE_APP_CMS_SPACE,
      accessToken: process.env.VUE_APP_CMS_ACCESS_TOKEN,
    });

    return client;
  },
};
